module.exports = __webpack_public_path__ + "img/8.84254331.png";